import styles from './style.module.css'


const NewsCardList = ({ children }) => {
  return <div className={styles.cardList}>
    {children}
  </div>
}

export default NewsCardList